var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { Formik, Form, Field } from 'formik';
import { FormikTextField, TYPES } from './FormikTextField';
import { Typography } from './Typography';
import { Button } from './Button';
import * as ServiceUtils from '../services/utils';
import { FormControlLabel, Switch, Grid, Stack, Alert } from '@mui/material';
import { ErrorIcon, SaveIcon } from './Icons';
var OPTIONS_ASYNC = {
    CONTACT: 'contacts',
    COLLABORATEUR: 'collaborateurs',
    CLIENT: 'clients',
};
var FormikGenerator = function (props) {
    var title = props.title, fields = props.fields, onSubmit = props.onSubmit, submitLabel = props.submitLabel, submitIcon = props.submitIcon, renderHeader = props.renderHeader, renderContent = props.renderContent, renderSubmit = props.renderSubmit, _a = props.datas, datas = _a === void 0 ? {} : _a, _b = props.additionalInitialValues, additionalInitialValues = _b === void 0 ? [] : _b, _c = props.validationSchema, validationSchema = _c === void 0 ? null : _c, _d = props.validate, validate = _d === void 0 ? null : _d, _e = props.enableReinitialize, enableReinitialize = _e === void 0 ? false : _e, _f = props.useDirty, useDirty = _f === void 0 ? true : _f;
    var _g = useState(null), messageError = _g[0], setMessageError = _g[1];
    var _h = useState(null), messageErrorOnSubmit = _h[0], setMessageErrorOnSubmit = _h[1];
    var initialValues = fields.flat().reduce(function (objet, item) {
        var defaultValue = datas[item.name]
            ? datas[item.name]
            : item.defaultValue !== undefined && item.defaultValue !== null
                ? item.defaultValue
                : null;
        objet[item.name] = defaultValue;
        return objet;
    }, {});
    for (var _i = 0, additionalInitialValues_1 = additionalInitialValues; _i < additionalInitialValues_1.length; _i++) {
        var additionalInitialValue = additionalInitialValues_1[_i];
        initialValues[additionalInitialValue] = datas[additionalInitialValue];
    }
    var handleAsyncOptions = function (nameAsyncOptions, search) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ServiceUtils.getSelectOptions(nameAsyncOptions, {
                        search: search,
                    })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); };
    var renderSwitch = function (_a) {
        var field = _a.field, values = _a.values, setFieldValue = _a.setFieldValue, _b = _a.afterChange, afterChange = _b === void 0 ? null : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c;
        var getEntries = function (o, prefix) {
            if (prefix === void 0) { prefix = ''; }
            return Object.entries(o).flatMap(function (_a) {
                var k = _a[0], v = _a[1];
                return Object(v) === v
                    ? getEntries(v, "".concat(prefix).concat(k, "."))
                    : [["".concat(prefix).concat(k), v]];
            });
        };
        var getValuesFormated = function () {
            return getEntries(values).reduce(function (accumulator, item) {
                accumulator[item[0]] = item[1];
                return accumulator;
            }, {});
        };
        return (_jsx(FormControlLabel, { control: _jsx(Field, { label: field.label, name: field.name, disabled: field.disabled, component: Switch, checked: !!getValuesFormated()[field.name.replace('[', '.').replace(']', '')], onChange: function (e) {
                    setFieldValue(field.name, e.target.checked);
                    if (afterChange) {
                        afterChange(e.target.checked);
                    }
                } }), label: field.label }));
    };
    var isRequired = function (schema, fieldName) {
        return (schema &&
            schema.describe().fields[fieldName] &&
            schema
                .describe()
                .fields[fieldName].tests.findIndex(function (_a) {
                var name = _a.name;
                return name === 'required';
            }) >=
                0);
    };
    var renderField = function (_a) {
        var field = _a.field, values = _a.values, setFieldValue = _a.setFieldValue, errors = _a.errors;
        var contentField = field.type === TYPES.BOOLEAN ? (renderSwitch({
            field: field,
            values: values,
            setFieldValue: setFieldValue,
            afterChange: field.afterChange,
            disabled: field.disabled,
        })) : (_jsx(Field, { fullWidth: true, name: field.name, type: field.type, autoFocus: field.autoFocus, disabled: field.disabled, afterChange: function (value) {
                if (field.afterChange) {
                    field.afterChange(value, values, setFieldValue);
                }
            }, multiline: field.multiline, options: field.options, onChange: field.onChange, onlyDigits: field.onlyDigits, smallerThanZero: field.smallerThanZero, datePicker: field.datePicker, datetimePicker: field.datetimePicker, multiple: field.multiple, helperText: field.helperText, uppercase: field.uppercase, uppercaseFirstChar: field.uppercaseFirstChar, handleAsyncOptions: field.asyncOptions
                ? function (search) { return handleAsyncOptions(field.asyncOptions, search); }
                : undefined, label: field.label &&
                (field.isRequired || isRequired(validationSchema, field.name))
                ? "".concat(field.label, " *")
                : field.label, InputProps: field.startIcon || field.endIcon
                ? {
                    startAdornment: field.startIcon,
                    endAdornment: field.endIcon,
                }
                : undefined, component: FormikTextField }));
        return (_jsx(Grid, __assign({ item: true, xs: 12, md: field.xs ? field.xs : 12, className: "w-full" }, { children: field.afterComponent ? (_jsxs(Stack, __assign({ direction: "row" }, { children: [contentField, field.afterComponent] }))) : (contentField) }), field.name));
    };
    return (_jsxs(_Fragment, { children: [title && _jsx(Typography, __assign({ variant: "h2" }, { children: title })), _jsx(Formik, __assign({ enableReinitialize: enableReinitialize, validationSchema: validationSchema, initialValues: initialValues, validate: function (values) {
                    var newMessageError = null;
                    var errors = {};
                    if (validate) {
                        newMessageError = validate({ values: values, errors: errors });
                    }
                    setMessageError(newMessageError);
                    setMessageErrorOnSubmit(null);
                    return errors;
                }, onSubmit: function (values, _a) {
                    var setSubmitting = _a.setSubmitting, resetForm = _a.resetForm;
                    return __awaiter(void 0, void 0, void 0, function () {
                        var results, error_1;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    _b.trys.push([0, 2, , 3]);
                                    results = __assign({}, values);
                                    return [4 /*yield*/, onSubmit(results, { resetForm: resetForm })];
                                case 1:
                                    _b.sent();
                                    return [3 /*break*/, 3];
                                case 2:
                                    error_1 = _b.sent();
                                    setMessageErrorOnSubmit(error_1.message);
                                    console.error(error_1.message);
                                    return [3 /*break*/, 3];
                                case 3:
                                    setSubmitting(false);
                                    return [2 /*return*/];
                            }
                        });
                    });
                } }, { children: function (_a) {
                    var isSubmitting = _a.isSubmitting, handleSubmit = _a.handleSubmit, setFieldValue = _a.setFieldValue, setFieldTouched = _a.setFieldTouched, setValues = _a.setValues, values = _a.values, dirty = _a.dirty, errors = _a.errors;
                    var IconSubmit = submitIcon ? submitIcon : SaveIcon;
                    return (_jsxs(Form, __assign({ onSubmit: handleSubmit }, { children: [renderHeader &&
                                renderHeader({
                                    values: values,
                                    renderField: function (field) {
                                        return renderField({
                                            field: field,
                                            values: values,
                                            setFieldValue: setFieldValue,
                                            errors: errors,
                                        });
                                    },
                                    setFieldValue: setFieldValue,
                                    setFieldTouched: setFieldTouched,
                                }), _jsx(Grid, __assign({ container: true, spacing: 1 }, { children: fields.map(function (fieldContainer, index) { return (_jsx(Grid, __assign({ item: true, container: true, spacing: 1 }, { children: fieldContainer
                                        .filter(function (field) {
                                        return field.show === undefined ||
                                            (field.show && field.show(values));
                                    })
                                        .map(function (field) {
                                        return renderField({
                                            field: field,
                                            values: values,
                                            setFieldValue: setFieldValue,
                                            errors: errors,
                                        });
                                    }) }), index)); }) })), renderContent &&
                                renderContent({
                                    values: values,
                                    renderField: function (field) {
                                        return renderField({
                                            field: field,
                                            values: values,
                                            setFieldValue: setFieldValue,
                                            errors: errors,
                                        });
                                    },
                                    setFieldValue: setFieldValue,
                                    setFieldTouched: setFieldTouched,
                                    setValues: setValues,
                                }), !isSubmitting && (messageError || messageErrorOnSubmit) && (_jsx(Alert, __assign({ className: "mt-small", variant: "outlined", severity: "error" }, { children: messageError || messageErrorOnSubmit }))), _jsx(Stack, __assign({ direction: "row", justifyContent: "flex-end", alignItems: "flex-end", className: "m-small", spacing: 2 }, { children: renderSubmit ? (renderSubmit({ isSubmitting: isSubmitting })) : (_jsxs(Button, __assign({ type: "submit", loading: isSubmitting, disabled: isSubmitting ||
                                        (useDirty && !dirty) ||
                                        !!messageError ||
                                        Object.keys(errors).length > 0, className: "m-small" }, { children: [!!messageError || Object.keys(errors).length > 0 ? (_jsx(ErrorIcon, { fontSize: "small", color: "error", className: "mr-xsmall" })) : (_jsx(IconSubmit, { fontSize: "small", className: "mr-xsmall" })), submitLabel ? submitLabel : 'Valider'] }))) }))] })));
                } }))] }));
};
export { FormikGenerator, OPTIONS_ASYNC, TYPES };
//# sourceMappingURL=FormikGenerator.js.map